import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-job-accept-popup',
	standalone: true,
	imports: [CommonModule, MatIconModule],
	templateUrl: './job-accept-popup.component.html',
	styleUrl: './job-accept-popup.component.scss'
})
export class JobAcceptPopupComponent {


	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<JobAcceptPopupComponent>
	) { }


	closeDialog() {
		this.dialogRef.close();
	}

	confirmApproval() {
		this.dialogRef.close(true)
	}

}
